import { Col } from "react-bootstrap";
import navIcon3 from '../assets/img/nav-icon3.svg';
import outIcon from '../assets/img/out-icon.png';
import behanceIcon from '../assets/img/behance-icon.png';
export const ProjectCard = ({ title, description, imgUrl,repository,deploy,behance }) => {

  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} alt="preview1"/>
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
          <div className="social-icon" style={{justifyContent:'center',marginTop:'10px',}}>
            {repository ? <a href={repository}><img style={{width:"60%",margin:'2px 0px 0px -1.5px'}}src={navIcon3} alt="photo1" /></a> : ""}
            {deploy ? <a href={deploy}><img style={{width:"50%"}}src={outIcon} alt="photo2" /></a> : " "}
            {behance ?<a href={behance}><img style={{width:"50%"}}src={behanceIcon} alt="photo3" /></a> : " "}
            <i className="fa-solid fa-display-code"></i>
      </div>
        </div>
      </div>

    </Col>
  )
}
